<template>
  <div class="home">

    <h1> IRFS-16 </h1>
    <img src="../../public/images/web/hero.png" alt="hero" class="hero">

    <div class="options">
      <button @click="$router.push('basic-info')"> Enter new lease </button>
      <button> Views </button>
      <button> Reports </button>
      <button> Admin </button>
    </div>
    
  </div>
</template>

<script>

export default {
  components: {
    
  }
}
</script>

<style scoped>
  .hero {
    display: block;
    height: 400px;
    width: 100%;
    margin-top: 40px;
    opacity: 0.6;
    object-fit: contain;
  }
  .options {
    display: flex;
  }
  .options button {
    margin: 40px 20px 0;
  }
</style>
